import { render, staticRenderFns } from "./ClaimAffiliateRewardSetting.vue?vue&type=template&id=48a60476&"
import script from "./ClaimAffiliateRewardSetting.vue?vue&type=script&lang=js&"
export * from "./ClaimAffiliateRewardSetting.vue?vue&type=script&lang=js&"
import style0 from "./ClaimAffiliateRewardSetting.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports